import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const CreateHiddenExcelTable = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateHiddenExcelTable,
        method: RequestType.POST,
        data,
    });

const UpdateHiddenExcelTable = (id: number, data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpdateHiddenExcelTable}/${id}`,
        method: RequestType.PUT,
        data,
    });

const DeleteHiddenExcelTable = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Command.DeleteHiddenExcelTable}/${id}`,
        method: RequestType.DELETE,
    });

const HiddenExcelCommand = {
    CreateHiddenExcelTable,
    UpdateHiddenExcelTable,
    DeleteHiddenExcelTable,
};

export default HiddenExcelCommand;
